/** r8 home entrance motion. Shopify owns product data, navigation and purchases. */
(() => {
  const hero = document.querySelector('.fp-atelier-hero');
  if (!hero) return;
  const main = hero.closest('main');
  if (!main) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches || !('IntersectionObserver' in window)) return;

  const targets = '.fp-atelier-section__head,.fp-atelier-category,.fp-atelier-products>.fp-product-wrap,.fp-atelier-source>img,.fp-atelier-source>div,.fp-atelier-finder__image,.fp-atelier-finder__content,.fp-atelier-services';
  const pending = new Set();
  const visited = new WeakSet();
  const scroller = main.closest('.page-wrapper');
  let frame = 0;
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) show(entry.target, true);
  }, { rootMargin: '0px', threshold: 0 });

  function show(element, stagger = false) {
    if (!pending.has(element)) return;
    const index = Array.prototype.indexOf.call(element.parentElement?.children || [], element);
    element.style.transitionDelay = stagger ? `${Math.min(Math.max(index, 0), 4) * 80}ms` : '0ms';
    element.classList.add('is-visible');
    pending.delete(element);
    observer.unobserve(element);
  }

  function onScreen(element) {
    const rect = element.getBoundingClientRect();
    const clip = scroller?.getBoundingClientRect();
    const top = clip?.height ? Math.max(0, clip.top) : 0;
    const bottom = clip?.height ? Math.min(window.innerHeight, clip.bottom) : window.innerHeight;
    return rect.top < bottom && rect.bottom > top;
  }

  function prepare(root) {
    if (motion.matches) return;
    const elements = [...root.querySelectorAll(targets)];
    if (root.matches?.(targets)) elements.unshift(root);
    for (const element of elements) {
      if (visited.has(element)) continue;
      visited.add(element);
      // CSS owns fragment-arrival motion, including when this module arrives late.
      if (element.closest('.fp-finder-entry .fp-atelier-finder')) continue;
      // The first screen stays readable immediately. Only offscreen blocks wait.
      if (onScreen(element) || window.Shopify?.designMode) continue;
      observer.observe(element);
      pending.add(element);
      element.classList.add('fp-home-reveal');
    }
  }

  function checkViewport() {
    frame = 0;
    for (const element of pending) {
      if (!element.isConnected) { observer.unobserve(element); pending.delete(element); }
      else if (onScreen(element)) show(element, true);
    }
  }

  function scheduleCheck() {
    if (!frame && pending.size) frame = requestAnimationFrame(checkViewport);
  }

  if (!window.Shopify?.designMode) document.body.classList.add('fp-home-motion');
  prepare(main);
  // Capture also covers the storefront's inner scroller when the advisor is open.
  document.addEventListener('scroll', scheduleCheck, { passive:true, capture:true });
  window.addEventListener('resize', scheduleCheck, { passive:true });
  main.addEventListener('focusin', event => {
    const element = event.target.closest('.fp-home-reveal');
    if (element) show(element);
  });
  document.addEventListener('shopify:section:load', event => { if (main.contains(event.target)) prepare(event.target); });
  document.addEventListener('shopify:section:unload', event => {
    for (const element of pending) if (event.target.contains(element)) show(element);
  });
  document.addEventListener('shopify:section:select', event => {
    for (const element of pending) if (event.target.contains(element)) show(element);
  });
  motion.addEventListener('change', event => {
    if (!event.matches) return;
    document.body.classList.remove('fp-home-motion');
    for (const element of pending) show(element);
    observer.disconnect();
  });
})();
